/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_No_Project_File_SelectedInputs */

const en_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error - No project file selected`)
};

const fr_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur - Aucun fichier de projet sélectionné`)
};

const de_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler – Keine Projektdatei ausgewählt`)
};

const it_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore - Nessun file di progetto selezionato`)
};

const ru_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка — не выбран файл проекта`)
};

const es_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: No hay ningún archivo de proyecto seleccionado`)
};

const zh_cn2_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误 - 未选择项目文件`)
};

const ja_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー - プロジェクト ファイルが選択されていません`)
};

const hi_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि - कोई प्रोजेक्ट फ़ाइल चयनित नहीं है`)
};

const pt_pt2_error_no_project_file_selected = /** @type {(inputs: Error_No_Project_File_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro - Nenhum arquivo de projeto selecionado`)
};

/**
* | output |
* | --- |
* | "Error - No project file selected" |
*
* @param {Error_No_Project_File_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_no_project_file_selected = /** @type {((inputs?: Error_No_Project_File_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_No_Project_File_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_no_project_file_selected(inputs)
	if (locale === "de") return de_error_no_project_file_selected(inputs)
	if (locale === "it") return it_error_no_project_file_selected(inputs)
	if (locale === "ru") return ru_error_no_project_file_selected(inputs)
	if (locale === "es") return es_error_no_project_file_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_error_no_project_file_selected(inputs)
	if (locale === "ja") return ja_error_no_project_file_selected(inputs)
	if (locale === "hi") return hi_error_no_project_file_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_error_no_project_file_selected(inputs)
	return en_error_no_project_file_selected(inputs)
});